var exports = {
  "kL": "MatureContentChannelGate.module__container___aWgzQl",
  "Qs": "MatureContentChannelGate.module__content___aWgzQl",
  "DD": "MatureContentChannelGate.module__title___aWgzQl",
  "h_": "MatureContentChannelGate.module__description___aWgzQl",
};

module.exports = exports;
